import * as d3 from "d3";
import {ITypeRadar} from "../../../types";
import {
  ICircleRadiusItem,
  sizeCircleRadiusWeaksignal,
} from "../../../mocks/projectsMock";

const renderMaturityLabels = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  firstCircleRadius: ICircleRadiusItem,
  secondCircleRadius: ICircleRadiusItem,
  thirdCircleRadius: ICircleRadiusItem,
  fourthCircleRadius: ICircleRadiusItem,
  typeRadar: ITypeRadar,
  isWeak_signal?: boolean
) => {
  let maturityLabels: {label: string; radius: number}[];
  if (!isWeak_signal) {
    maturityLabels = [
      {
        label: typeRadar === "stateInitiative" ? "Масштабирование" : "ВЫСОКАЯ",
        radius:
          firstCircleRadius.radius +
          (secondCircleRadius.radius - firstCircleRadius.radius) / 2,
      },
      {
        label: typeRadar === "stateInitiative" ? "Пилот" : "СРЕДНЯЯ",
        radius:
          secondCircleRadius.radius +
          (thirdCircleRadius.radius - secondCircleRadius.radius) / 2,
      },
      {
        label:
          typeRadar === "stateInitiative"
            ? "Общественное обсуждение"
            : "НИЗКАЯ",
        radius:
          thirdCircleRadius.radius +
          (fourthCircleRadius.radius - thirdCircleRadius.radius) / 2,
      },
    ];
  } else {
    maturityLabels = [
      {
        label: "ВЫСОКАЯ",
        radius:
          (sizeCircleRadiusWeaksignal.firstCircleRadius.radius +
            sizeCircleRadiusWeaksignal.secondCircleRadius.radius) /
          2,
      },
      {
        label: "НИЗКАЯ",
        radius:
          (sizeCircleRadiusWeaksignal.thirdCircleRadius.radius +
            sizeCircleRadiusWeaksignal.secondCircleRadius.radius) /
          2,
      },
    ];
  }

  let headerLabel: string;
  if (!isWeak_signal) {
    headerLabel =
      typeRadar === "moleculeTwo"
        ? "СИНЕРГИЯ"
        : typeRadar === "stateInitiative"
        ? "ЭТАП ЖИЗНЕННОГО ЦИКЛА"
        : "СТАДИИ ЗРЕЛОСТИ";
  } else {
    headerLabel = "ЧАСТОТНОСТЬ";
  }
  const headerPaddingX = 5;
  const headerPaddingY = 3;
  const headerTextWidth = 10 * headerLabel.length;
  const headerBackgroundWidth = headerTextWidth + headerPaddingX * 2;
  const headerBackgroundHeight = 15 + headerPaddingY * 2;

  const headerY =
    typeRadar === "moleculeTwo"
      ? -fourthCircleRadius.radius - 30
      : -fourthCircleRadius.radius;

  if (typeRadar !== "fintech" || isWeak_signal) {
    mainGroup
      .append("rect")
      .attr("x", -headerBackgroundWidth / 2)
      .attr("y", headerY - headerBackgroundHeight / 2)
      .attr("width", headerBackgroundWidth)
      .attr("height", headerBackgroundHeight)
      .attr("fill", "#32364B")
      .attr("rx", 11)
      .attr("ry", 11);

    mainGroup
      .append("text")
      .attr("x", 0)
      .attr("y", headerY)
      .text(headerLabel)
      .style("fill", "#FFFFFF")
      .style("font-size", "10px")
      .style("font-weight", "400")
      .style("text-anchor", "middle")
      .attr("dy", "0.35em");

    maturityLabels.forEach(({label, radius}) => {
      const angle = -90;
      const textX = Math.cos((angle * Math.PI) / 180) * radius;
      const textY = Math.sin((angle * Math.PI) / 180) * radius;

      // Проверяем, нужно ли разбить текст на две строки
      const isPublicDiscussion = label === "Общественное обсуждение";
      let lines: string[] = [];
      let textWidth = 0;
      let backgroundHeight = 15;

      if (isPublicDiscussion) {
        lines = ["Общественное", "обсуждение"];
        // Измеряем ширину самой длинной строки
        const tempText1 = mainGroup
          .append("text")
          .text(lines[0])
          .style("font-size", "10px")
          .style("font-weight", "400")
          .style("visibility", "hidden");
        const tempText2 = mainGroup
          .append("text")
          .text(lines[1])
          .style("font-size", "10px")
          .style("font-weight", "400")
          .style("visibility", "hidden");

        const width1 = tempText1.node()?.getComputedTextLength() || 0;
        const width2 = tempText2.node()?.getComputedTextLength() || 0;
        textWidth = Math.max(width1, width2);
        backgroundHeight = 30; // Увеличиваем высоту для двух строк

        tempText1.remove();
        tempText2.remove();
      } else {
        lines = [label];
        const tempText = mainGroup
          .append("text")
          .text(label)
          .style("font-size", "10px")
          .style("font-weight", "400")
          .style("visibility", "hidden");

        textWidth = tempText.node()?.getComputedTextLength() || 0;
        tempText.remove();
      }

      const paddingX = 10;
      const paddingY = 3;
      const backgroundWidth = textWidth + paddingX * 2;
      const totalBackgroundHeight = backgroundHeight + paddingY * 2;

      mainGroup
        .append("rect")
        .attr("x", textX - backgroundWidth / 2)
        .attr("y", textY - totalBackgroundHeight / 2)
        .attr("width", backgroundWidth)
        .attr("height", totalBackgroundHeight)
        .attr("fill", "#32364B")
        .attr("rx", 11)
        .attr("ry", 11);

      if (isPublicDiscussion) {
        // Рендерим две строки текста
        mainGroup
          .append("text")
          .attr("x", textX)
          .attr("y", textY - 5) // Смещаем первую строку вверх
          .text(lines[0])
          .style("fill", "#FFFFFF")
          .style("font-size", "10px")
          .style("font-weight", "400")
          .style("text-anchor", "middle")
          .attr("dy", "0.35em");

        mainGroup
          .append("text")
          .attr("x", textX)
          .attr("y", textY + 5) // Смещаем вторую строку вниз
          .text(lines[1])
          .style("fill", "#FFFFFF")
          .style("font-size", "10px")
          .style("font-weight", "400")
          .style("text-anchor", "middle")
          .attr("dy", "0.35em");
      } else {
        mainGroup
          .append("text")
          .attr("x", textX)
          .attr("y", textY)
          .text(label)
          .style("fill", "#FFFFFF")
          .style("font-size", "10px")
          .style("font-weight", "400")
          .style("text-anchor", "middle")
          .attr("dy", "0.35em");
      }
    });
  }
};

export default renderMaturityLabels;
